import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { format } from 'react-phone-input-auto-format';
import PropTypes from 'prop-types';
import { Mobile } from '@one-thd/sui-icons';
import { clickEvents } from '../../../../utils/analytics';
import { markCandidateAsPhoned } from '../../../../api/SlmService';
import './ContactButtons.scss';

const CallMeButton = ({ phoneNumber, candidateId }) => {

  const markAsViewed = () => {
    markCandidateAsPhoned(candidateId).catch((error) => {
      console.error('Error marking candidate as contacted', error);
    });
  };

  const handleClick = () => {
    clickEvents.candidatePageInteraction('contact', 'call', candidateId);
    markAsViewed();
  };

  if (!phoneNumber) {
    return (
      <div className="contact-button">
        <Button disabled>
          <span className="contact-button__icon">
            <Mobile
              size="small"
            />
          </span>
          <span className="contact-button__label">
            Call
          </span>
        </Button>
      </div>
    );
  }

  return (
    <div className="contact-button">
      <Tooltip
        channel="desktop"
        closeButton
        content={(
          <div className="contact-button__tooltip" data-testid="call-me-btn-tooltip">
            {format(phoneNumber || '')}
          </div>
        )}
        showClose={false}
      >
        <a
          href={`tel:${phoneNumber}`}
          className="slm__link-no-underline"
        >
          <div
            onClick={handleClick}
            className="contact-button__btn secondary"
          >
            <span className="contact-button__icon">
              <Mobile
                style={{ fontSize: '32px' }}
              />
            </span>
            <span className="contact-button__label">
              Call
            </span>
          </div>
        </a>
      </Tooltip>
    </div>
  );
};

CallMeButton.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  candidateId: PropTypes.number.isRequired
};

export default CallMeButton;
